import { motion } from 'framer-motion';
import { Shield, Award, Wrench, TrendingUp } from 'lucide-react';

{/*const features = [
  {
    icon: Shield,
    title: 'Tested & Certified',
    description: 'Every laptop undergoes rigorous 50-point inspection to ensure hero-level reliability.',
  },
  {
    icon: Award,
    title: '1-Year Warranty',
    description: 'Complete peace of mind with our comprehensive warranty coverage on all devices.',
  },
  {
    icon: Wrench,
    title: 'Professional Refurbishment',
    description: 'Expert technicians restore each laptop to peak performance standards.',
  },
  {
    icon: TrendingUp,
    title: 'Best Value',
    description: 'Premium quality at unbeatable prices - up to 70% off retail cost.',
  },
];*/}

export const AboutSection = () => {
  return (
    <section id="about" className="py-16 sm:py-24 bg-card/30 relative overflow-hidden">
      {/* Background effects */}
      <div className="absolute inset-0 bg-web-pattern opacity-20" />
      <motion.div
        className="absolute top-1/4 -right-48 w-96 h-96 bg-primary/10 rounded-full blur-3xl"
        animate={{
          x: [0, 50, 0],
          y: [0, 30, 0],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold mb-4 font-['Exo_2']">
            Our <span className="text-gradient-red">Story</span>
          </h2>
          <p className="text-muted-foreground text-lg max-w-3xl mx-auto">
            At Classic Laptop Mall, we believe everyone deserves access to powerful technology.
            We're on a mission to deliver premium refurbished laptops that perform like heroes.
          </p>
          <div className="web-separator w-24 mx-auto mt-6" />
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          {/* Image Side */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="relative aspect-video lg:aspect-square rounded-2xl overflow-hidden border-glow-red">
              <img
                src="https://images.unsplash.com/photo-1572509018340-1fc13b5df491?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwzfHxsYXB0b3AlMjBkYXJrfGVufDB8fHx8MTc2ODAxNjUxNnww&ixlib=rb-4.1.0&q=85"
                alt="Premium Laptop Workspace"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-background/80 to-transparent" />
            </div>

            {/* Floating stats badge */}
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: 0.5, duration: 0.5 }}
              className="absolute -bottom-6 -right-6 bg-primary/90 backdrop-blur-sm text-primary-foreground p-6 rounded-2xl shadow-2xl glow-red"
            >
              <div className="text-3xl font-bold font-['Exo_2']">Website</div>
              <div className="text-sm">Coming Soon</div>
            </motion.div>
          </motion.div>

          {/* Content Side */}
          <motion.div
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.8 }}
            className="space-y-6"
          >
            <h3 className="text-2xl sm:text-3xl font-bold font-['Exo_2']">
              Performance That <span className="text-primary">Never Quits</span>
            </h3>
            <p className="text-muted-foreground leading-relaxed">
              We believe everyone deserves access to reliable and powerful laptops without overpaying.

Every laptop we offer is carefully tested and restored to ensure smooth performance and long-term reliability.
            </p>
            <p className="text-muted-foreground leading-relaxed">
              Our focus is simple — quality laptops you can trust, backed by honest pricing and real performance.
            </p>
            <div className="flex flex-wrap gap-4 pt-4">
              {['Dell', 'HP', 'Lenovo', 'Apple'].map((brand, index) => (
                <motion.div
                  key={brand}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.2 + index * 0.1 }}
                  className="px-4 py-2 bg-muted/50 border border-primary/20 rounded-lg text-sm font-semibold"
                >
                  {brand}
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>

        {/* Features Grid 
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {features.map((feature, index) => {
            const Icon = feature.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                whileHover={{ y: -8 }}
                className="p-6 bg-card/50 backdrop-blur-sm border border-primary/20 rounded-xl hover:border-primary/50 transition-all duration-300 group"
              >
                <div className="w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center mb-4 group-hover:bg-primary/20 transition-colors">
                  <Icon className="w-6 h-6 text-primary" />
                </div>
                <h4 className="text-lg font-bold mb-2">{feature.title}</h4>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {feature.description}
                </p>
              </motion.div>
            );
          })}
        </div>*/}
      </div>
    </section>
  );
};